// extracted by mini-css-extract-plugin
export var cartContainer = "_q6-4";
export var gray = "_q6-1";
export var itemContainer = "_q6-2";
export var itemDetails = "_q6-3";
export var strong = "_q6-0";